const TAHAP_ADMIN = [
  { urutan: 1, tahap: 'Usulan/Proposal Penerima Bantuan', bobot: 5 },
  { urutan: 2, tahap: 'Validasi Faktual & Survei', bobot: 10 },
  { urutan: 3, tahap: 'Penyusunan RAB & Gambar', bobot: 10 },
  { urutan: 4, tahap: 'Penetapan Penerima Bantuan', bobot: 5 },
  { urutan: 5, tahap: 'Sosialisasi', bobot: 5 },
  { urutan: 6, tahap: 'SPK/Kontrak', bobot: 10 },
  { urutan: 7, tahap: 'Pemblokiran Rekening', bobot: 5 },
  { urutan: 8, tahap: 'Transfer Dana dari Dinas ke Penerima Bantuan', bobot: 10 },
  { urutan: 9, tahap: 'Pemeriksaan Akhir & BAST', bobot: 15 },
  { urutan: 10, tahap: 'SPJ Lengkap & Disetujui', bobot: 25 },
];

export const ADM_FILE_BASE = 'adm-bantuan';
export const RAB_ADM_FILE_BASE = 'rab-progress-administrasi';

export function parseAdmMaps(admBantuan) {
  if (!admBantuan) return { dokumen: {}, foto: {} };
  try {
    return {
      dokumen: admBantuan.dokumen ? JSON.parse(admBantuan.dokumen) : {},
      foto: admBantuan.foto ? JSON.parse(admBantuan.foto) : {},
    };
  } catch {
    return { dokumen: {}, foto: {} };
  }
}

/** Bangun langkah administrasi dari AdmBantuan (sebelum / tanpa RAB progress) */
export function buildStepsFromAdmBantuan(admBantuan) {
  if (!admBantuan) return [];
  const { dokumen, foto } = parseAdmMaps(admBantuan);
  return TAHAP_ADMIN.map((t) => {
    const key = String(t.urutan);
    const docs = dokumen[key] || [];
    const fotos = foto[key] || [];
    const hasFiles = docs.length > 0 || fotos.length > 0;
    return {
      id: `adm-${t.urutan}`,
      urutan: t.urutan,
      tahap: t.tahap,
      bobot: t.bobot,
      status: hasFiles ? 'Sedang Berlangsung' : 'Belum Dimulai',
      dokumen: docs.length ? JSON.stringify(docs) : null,
      foto: fotos.length ? JSON.stringify(fotos) : null,
      readOnly: true,
    };
  });
}

/** Gabungkan progress RAB dengan fallback AdmBantuan per tahap */
export function mergeAdministrasiProgress(progressAdministrasi, admBantuan) {
  if (!admBantuan) {
    return (progressAdministrasi || []).map((s) => ({ ...s }));
  }

  const { dokumen, foto } = parseAdmMaps(admBantuan);

  if (!progressAdministrasi?.length) {
    return buildStepsFromAdmBantuan(admBantuan);
  }

  return progressAdministrasi.map((step) => {
    const key = String(step.urutan);
    const admDocs = dokumen[key] || [];
    const admFotos = foto[key] || [];

    let stepDok = [];
    let stepFoto = [];
    try { stepDok = step.dokumen ? JSON.parse(step.dokumen) : []; } catch { stepDok = []; }
    try { stepFoto = step.foto ? JSON.parse(step.foto) : []; } catch { stepFoto = []; }

    const mergedDok = stepDok.length > 0 ? stepDok : admDocs;
    const mergedFoto = stepFoto.length > 0 ? stepFoto : admFotos;

    return {
      ...step,
      dokumen: mergedDok.length ? JSON.stringify(mergedDok) : null,
      foto: mergedFoto.length ? JSON.stringify(mergedFoto) : null,
      status: step.status === 'Belum Dimulai' && (mergedDok.length || mergedFoto.length)
        ? 'Sedang Berlangsung'
        : step.status,
    };
  });
}

export function calcAdmOnlyPercent(admBantuan) {
  if (!admBantuan) return { presentase: 0, langkahSelesai: 0, totalLangkah: TAHAP_ADMIN.length };
  const { dokumen, foto } = parseAdmMaps(admBantuan);
  let filled = 0;
  TAHAP_ADMIN.forEach((t) => {
    const key = String(t.urutan);
    if ((dokumen[key]?.length || 0) > 0 || (foto[key]?.length || 0) > 0) filled += 1;
  });
  return {
    presentase: Math.round((filled / TAHAP_ADMIN.length) * 100),
    langkahSelesai: filled,
    totalLangkah: TAHAP_ADMIN.length,
  };
}

function detectFileBase(filename) {
  if (!filename) return 'rab-progress-administrasi';
  if (filename.startsWith('SK_')) return 'rab-progress-administrasi';
  if (filename.startsWith('admb_')) return 'adm-bantuan';
  if (filename.startsWith('rabadm_')) return 'rab-progress-administrasi';
  if (filename.startsWith('rabfisik_')) return 'rab-progress-fisik';
  if (filename.startsWith('rabprogress_')) return 'rab-progress';
  if (filename.startsWith('rab_')) return 'rab';
  if (filename.startsWith('bantuan_')) return 'images';
  return 'rab-progress-administrasi';
}

export function getAdmFileUrl(filename, fileBase, baseUrl) {
  if (!filename) return '';
  const root = (baseUrl || process.env.REACT_APP_URL || 'http://localhost:5100').replace(/\/$/, '');
  const name = String(filename).trim();
  if (name.startsWith('http') || name.startsWith('blob:') || name.startsWith('data:')) return name;
  const basename = name.split('/').pop();
  if (basename.startsWith('BA_Verifikasi_') || basename.startsWith('BA_Signed_')) {
    return `${root}/ba/${basename}`;
  }
  // path relatif yang sudah memuat folder
  if (name.includes('/')) {
    const cleaned = name.replace(/^\/+/, '').replace(/^uploads\//, '');
    return `${root}/files/${cleaned}`;
  }
  const base = fileBase || detectFileBase(filename);
  return `${root}/files/${base}/${filename}`;
}
